// extracted by mini-css-extract-plugin
module.exports = {"navHeader":"LogoutHeader_navHeader__2xomN"};